import { render } from "./LibraryForm.vue?vue&type=template&id=bd73ea08&scoped=true"
import script from "./LibraryForm.vue?vue&type=script&lang=js"
export * from "./LibraryForm.vue?vue&type=script&lang=js"

import "./LibraryForm.vue?vue&type=style&index=0&id=bd73ea08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd73ea08"]])

export default __exports__